import { useCallback, useContext } from 'react'
import { I18nContext } from './I18nContext'

export const useI18n = () => useCallback(useContext(I18nContext), [])

export const useT = () => {
  const { formatMessage } = useI18n()
  const t = useCallback((id, params) => formatMessage({ id }, params).trim(), [])
  return t
}
